module.exports = __webpack_public_path__ + "img/WellsFargo.b2d6acd1.svg";